import React from "react";
import Typography from "@mui/material/Typography";

const ParceiroAgregadoTopo = () => {
  return (
    <React.Fragment>
      <div className="containerTitle">
        <Typography
          variant="h5"
          fontFamily={"Co Headline Regular"}
          gutterBottom
          align="left"
          marginLeft="15px"
        >
          Parceiro Agregado
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default ParceiroAgregadoTopo;
